<div 
  class="identification-pill"
  [ngClass]="{
    'default': theme === 'default',
    'proofing': theme === 'proofing'
  }"
>
  {{ accessGroup | titlecase }}
</div>